import { Injectable } from '@angular/core';
import { AuthStateService } from '../../auth/auth-state-service';
import { jwtDecode } from 'jwt-decode';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

const TOKEN_KEY = 'token';
const REFRESH_TOKEN_KEY = 'refresh_token';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private tokenSubject: BehaviorSubject<string | null>;
  public token$: Observable<string | null>

  constructor(private authStateService: AuthStateService) {
    const initialToken = this.getToken();
    this.tokenSubject = new BehaviorSubject<string | null>(initialToken);
    this.token$ = this.tokenSubject.asObservable();
  }

  getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY);
  }

  setToken(token: string): void {
    localStorage.setItem(TOKEN_KEY, token);
    this.tokenSubject.next(token);
  }

  getRefreshToken(): string | null {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  }

  setRefreshToken(refreshToken: string): void {
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  }

  clearTokens(): void {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    this.tokenSubject.next(null);
  }

  hasValidToken(): boolean {
    const token = this.getToken();
    if (!token) return false;

    const decodedToken = this.decodeToken(token);
    if (!decodedToken || !decodedToken.exp) {
      return false;
    }

    const currentTime = Math.floor(Date.now() / 1000);
    return decodedToken.exp > currentTime;
  }

  private decodeToken(token: string): any {
    try {
      return jwtDecode(token);
    } catch (e) {
      console.error('[TokenService] Erro ao decodificar o token:', e);
      return null
    }
    return null
  }

  public decodeTheToken(token: string): any {
    return this.decodeToken(token);
  }

  getTokenFieldName(): string {
    const authMethod = this.authStateService.getAuthMethod();
    return authMethod === 'gov' ? '_tokenGovBrForm' : '_tokenPingIdForm';
  }

  prepareFormTokenField(token: string): HTMLInputElement {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = this.getTokenFieldName();
    input.value = token;
    return input;
  }

  getRolesFromToken(): string[] {
    const token = this.getToken();
    if (!token) return [];

    try {
      const decodedToken: any = jwtDecode(token);
      if (decodedToken.roles && typeof decodedToken.roles === 'string') {
        return decodedToken.roles.split(',');
      }
      if (Array.isArray(decodedToken.roles)) {

        if (!environment.production && environment.env == 'dev') {
          decodedToken.roles.push('PORTALCAU_PRIVILEGIADO_BVMF');
        }
        return decodedToken.roles;
      }
      return [];
    } catch (error) {
      console.error('Erro ao decodificar o token:', error);
      return [];
    }
  }

  getUserNameFromToken(): string {
    const token = this.getToken();
    if (!token) return 'User';

    try {
      const decodedToken: any = jwtDecode(token);
      return decodedToken.name || 'User';
    } catch (error) {
      console.error('Erro ao decodificar o token:', error);
      return 'User';
    }
  }
}
